import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { UserRole } from '../../role/user-role/user-role'
import { Observable } from 'rxjs'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'

@Component({
  selector: 'category-tab',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class CategoryTabComponent implements OnInit {
  public currentUserRole$: Observable<UserRole>
  constructor(private store: Store<AppState>, private router: Router) {}

  ngOnInit() {
    this.currentUserRole$ = this.store.select(
      persistentUserRoleSelectors.selectSelectedUserRole
    )
  }
}
